import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import Reveal from "@/components/common/Reveal";
import HoverGlow from "@/components/motion/HoverGlow";

export const PremiumSteps = ({ steps = [], testId }) => {
  const reduced = usePreferStaticUI();

  return (
    <ol className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid={testId}>
      {steps.map((step, i) => {
        const title = typeof step === "string" ? step : step.title;
        const body = typeof step === "object" && step.body ? step.body : null;

        return (
          <Reveal key={i} delay={i * 0.05}>
            <HoverGlow className="h-full">
              <li className="wit-bento-cell group flex gap-4 items-start h-full">
                <motion.span
                  className="w-8 h-8 rounded-full bg-roseMilk text-plum font-serif text-sm flex items-center justify-center shrink-0"
                  animate={
                    reduced
                      ? undefined
                      : {
                          boxShadow: [
                            "0 0 0 0 rgba(158, 74, 98, 0)",
                            "0 0 0 6px rgba(158, 74, 98, 0.08)",
                            "0 0 0 0 rgba(158, 74, 98, 0)",
                          ],
                        }
                  }
                  transition={{ duration: 3, repeat: Infinity, delay: i * 0.4 }}
                >
                  {i + 1}
                </motion.span>
                <div className="pt-0.5 min-w-0">
                  <p className="text-sm font-medium text-ink leading-snug">{title}</p>
                  {body && <p className="mt-1.5 text-sm text-warmGrey leading-relaxed">{body}</p>}
                </div>
              </li>
            </HoverGlow>
          </Reveal>
        );
      })}
    </ol>
  );
};

export default PremiumSteps;
